<ws-modal-wrapper
    headerLabel="User Group"
    [disableSave]="!editMode || saving || !userGroup.name"
    acceptLabel="Save"
    (save)="save()"
    [cancelLabel]="getCancelButtonText()"
    (cancel)="cancel()"
>
    @if (hasEditPermission && !(editMode || readOnly)) {
        <button class="ace-btn has-icon btn-primary float-end" (click)="editUserGroup()">
            <i class="fa fa-pencil"></i>
        </button>
    }
    @if (editMode) {
        <button
            class="ace-btn btn-primary btn-danger float-start"
            [disabled]="saving || !userGroup.groupID"
            (click)="deleteUserGroup()"
        >
            Delete
        </button>
    }
    @if (userGroup) {
        <user-group-name-info [userGroup]="userGroup" [canEdit]="editMode"> </user-group-name-info>
        <application-permission-panel [userGroup]="userGroup" [canEdit]="!editMode"> </application-permission-panel>
        <instance-permission-panel [userGroup]="userGroup" [canEdit]="editMode"> </instance-permission-panel>
        <company-permission-panel [userGroup]="userGroup" [canEdit]="editMode"> </company-permission-panel>
    }
</ws-modal-wrapper>
